import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Popconfirm, message, Modal, Tabs, Button, Input, Select } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import UpdateDoctor from './UpdateDoctor';
import PreviewModal from './PreviewModal';
import ExportModal from './ExportModal';
import SideNav from '../SideNav';
import Filter from './Filter';
import Cooperation from '../UpdateJinshiCooperation';
import TransferStationRecord from './TransferStationRecord';
import { actions } from './store';
import fp from '../../../utils/fp';
import cf from "../../../utils/cf";
import setDefaultValue from '../../shared/setDefaultValue';
import TableC from '../../basicElement/TableC';
import PendingDoctorModal from './PendingDoctorModal';

const { TabPane } = Tabs;
const Option = Select.Option;

class DoctorList extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            sortParams: {},
            searchParams: { ...searchParams },
            data: [],
            pagination: {
                pageSize: 10,
                current: 1,
            },
            isAdd: false,
            loading: false,
            record: {},
            updateVisible: false,
            crcFlag: false,
            // pending doctor tab state
            pendingSearchParams: {},
            pendingData: [],
            pendingPagination: {
                pageSize: 10,
                current: 1,
            },
            pendingLoading: false,
        };
    }

    componentDidMount() {
        this.loadData();
        this.loadPendingData();
        this.judgeCrcHospotial();
    }

    componentDidUpdate(prevProps) {
        const { searchParams: prevSearchPrams } = prevProps;
        const { searchParams } = this.props;
        if (prevSearchPrams !== searchParams) {
            this.setState(prevState => ({
                searchParams: {
                    ...prevState.searchParams,
                    ...searchParams
                }
            }), () => {
                this.loadData();
            });
        }
    }

    componentWillUnmount() {
        this.props.saveSearchParams({});
    }

    loadData = () => {
        const { searchParams, sortParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.queryDoctorListByInves}`,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, data: { canAddDept }, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                    isAdd: canAddDept === 'TRUE',
                });
            }
        };
        $.sendRequest(options);
    }

    loadPendingData = () => {
        const { pendingSearchParams, pendingPagination } = this.state;
        const { current, pageSize } = pendingPagination;
        this.setState({ pendingLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.doctorPendingCooperationList,
            data: {
                offset: current,
                limit: pageSize,
                ...pendingSearchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pendingPagination.total = totalCount;
                this.setState({
                    pendingData: datas || [],
                    pendingPagination,
                    pendingLoading: false,
                });
            },
            errorResult: () => {
                this.setState({ pendingLoading: false });
            },
        };
        $.sendRequest(options);
    }

    judgeCrcHospotial = () => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.judgeCrcHospotial,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    crcFlag: res.crcFlag,
                });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    pendingSearch = () => {
        const { pendingPagination } = this.state;
        pendingPagination.current = 1;
        this.setState({
            pendingPagination,
        }, () => {
            this.loadPendingData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        this.exportModal.show(searchParams);
    }

    delete = record => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                const { userId, hospitalId, hospitalDepartmentId } = record;
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.delDoctor,
                    data: {
                        userId,
                        hospitalId,
                        enterpriseId: 1,
                        hospitalDepartmentId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    }
                };
                $.sendRequest(options);
            },
        });
    }

    pendingDelete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.hospital.doctorPendingCooperationDelete,
                    data: { doctorPendingCooperationId: record.doctorPendingCooperationId },
                    dataType: 'json',
                    doneResult: () => {
                        message.success("删除成功");
                        this.loadPendingData();
                    },
                });
            },
        });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams } });
    }

    handlePendingSearchChange = (value, key) => {
        const { pendingSearchParams } = this.state;
        pendingSearchParams[key] = value;
        this.setState({ pendingSearchParams });
    }

    getColumns = () => {
        const { crcFlag } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 200,
            sorter: true,
            sortType: 'common',
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '医生姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '性别',
            dataIndex: 'gender',
            key: 'gender',
            sorter: true,
            sortType: 'common',
            width: 80,
            render: text => text ? text === 'FEMALE' ? '女' : '男' : '',
        }];
        if (!crcFlag) {
            columns.push({
                title: '出生日期',
                dataIndex: 'birthDate',
                key: 'birthDate',
                width: 100,
            });
        }
        columns.push({
            title: '专业技术职称',
            dataIndex: 'professionalTitle',
            key: 'professionalTitle',
            width: 100,
        }, {
            title: '职务',
            dataIndex: 'doctorPosition',
            key: 'doctorPosition',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '固定电话',
            dataIndex: 'userTelphone',
            key: 'userTelphone',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '邮箱',
            dataIndex: 'userEmail',
            key: 'userEmail',
            sorter: true,
            sortType: 'common',
            width: 120
        }, {
            title: '接待时间',
            dataIndex: 'receptionTime',
            key: 'receptionTime',
            width: 100,
        }, {
            title: '接待地点',
            dataIndex: 'receptionPlace',
            key: 'receptionPlace',
            width: 100,
        });
        if (!crcFlag) {
            columns.push({
                title: '参与的项目数量',
                dataIndex: 'invesNum',
                key: 'invesNum',
                sorter: true,
                sortType: 'common',
                width: 140,
            }, {
                title: '临床项目身份',
                dataIndex: 'piIdentityShow',
                key: 'piIdentityShow',
                width: 100,
                render: (text, record) => {
                    const { identityMap } = record;
                    const entries = Object.entries(identityMap || {});
                    return (
                        entries.map((item, index) => {
                            return <span key={index} style={{ color: item[1] ? '#ccc' : '#000000a6'}}>{item[0]}{index < entries.length - 1 && '，'}</span>
                        })
                    )
                }
            }, {
                title: '是否为leading PI',
                dataIndex: 'leadingPiFlag',
                key: 'leadingPiFlag',
                width: 100,
                render: text => String(text) === 'true' ? '是' : (String(text) === 'false' ? '否' : '')
            }, {
                title: '在岗状态',
                width: 120,
                render: (text, record) => {
                    const { postStatus, postEndTime } = record;
                    const statusMap = {
                        ON: '在岗',
                        RETIRED: '退休',
                        LEFT: '离职',
                        DECEASED: '离世',
                    };
                    if (postStatus === 'ON') {
                        return <span>在岗</span>;
                    }
                    if (postStatus === 'RETIRED' || postStatus === 'LEFT' || postStatus === 'DECEASED') {
                        return <span>{statusMap[postStatus] || postStatus}</span>;
                    }
                    // OFF（已转岗）显示转岗记录链接
                    return (
                        <a onClick={() => this.showTransferStationRecord(record)}>
                            转岗({postEndTime && postEndTime.slice(0, 10)})
                        </a>
                    );
                },
            }, {
                title: '转岗医院',
                dataIndex: 'jobTransferHospitalDept',
                key: 'jobTransferHospitalDept',
                width: 200,
            }, {
                title: '与津石是否有合作',
                dataIndex: 'userCooperation',
                key: 'userCooperation',
                width: 120,
                render: (text, record) => {
                    const { systemCooperation } = record;
                    if (systemCooperation == 1) {
                        return '是';
                    } else {
                        return text == 1 ? '是' : '否';
                    }
                }
            });
        }
        columns.push(
            {
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 120,
                render: (text, record) => {
                    const { isCharge, postStatus, systemCooperation } = record;
                    const { crcFlag } = this.state;
                    const { curRole } = sessionStorage;
                    const operationCorrespondRoles = new Map([
                        ['edit', {
                            name: '修改',
                            display: isCharge === 1,
                            editable: true,
                            event: () => this.showUpdate(true, record),
                            roles: ['*'],
                        }],
                        ['delete', {
                            name: '删除',
                            display: isCharge === 1,
                            editable: true,
                            event: () => this.delete(record),
                            roles: ['*'],
                        }],
                        ['preview', {
                            name: '项目明细',
                            display: !crcFlag,
                            editable: true,
                            event: () => this.showPreviewModal(record),
                            roles: ['*'],
                        }],
                        ['editCooperation', {
                            name: '修改津石合作情况',
                            display: isCharge === 1 && systemCooperation == 0 && postStatus == 'ON',
                            editable: true,
                            event: () => this.showCooperation(record),
                            roles: ['*'],
                        }],
                    ]);
                    return (
                        <span className="operateBarLineWrap">
                            {
                                fp.compose(
                                    fp.curry(cf.operationAuthByRole)(
                                        index => <span key={index} className="ant-divider" />
                                    ),
                                    fp.curry(setDefaultValue)('-'),
                                    fp.filter(i => !!i),
                                    fp.curry(cf.authDomList)(operationCorrespondRoles)
                                )(curRole)
                            }
                        </span>
                    );
                }
            }
        )
        return columns;
    }

    getPendingColumns = () => {
        const { menuAuth = {} } = this.props;
        const positionRole = sessionStorage.positionRole;
        const hasPendingPermission = positionRole === 'CRCC' || positionRole === 'CRCM' || positionRole === 'PML' || !!menuAuth.areaChargeUser || sessionStorage.isClinicalBO === 'true';

        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 180,
        }, {
            title: '院区名称',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: '科室',
            dataIndex: 'deptName',
            key: 'deptName',
            width: 120,
        }, {
            title: '医生姓名',
            dataIndex: 'doctorName',
            key: 'doctorName',
            width: 100,
        }, {
            title: '性别',
            dataIndex: 'gender',
            key: 'gender',
            width: 60,
            render: text => text ? (text === 'FEMALE' ? '女' : '男') : '',
        }, {
            title: '出生日期',
            dataIndex: 'birthDate',
            key: 'birthDate',
            width: 100,
        }, {
            title: '专业技术职称',
            dataIndex: 'professionalTitle',
            key: 'professionalTitle',
            width: 100,
        }, {
            title: '职务',
            dataIndex: 'doctorPosition',
            key: 'doctorPosition',
            width: 100,
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
            width: 120,
        }, {
            title: '固定电话',
            dataIndex: 'userTelephone',
            key: 'userTelephone',
            width: 100,
        }, {
            title: '邮箱',
            dataIndex: 'userEmail',
            key: 'userEmail',
            width: 120,
        }, {
            title: '接待时间',
            dataIndex: 'receptionTime',
            key: 'receptionTime',
            width: 100,
        }, {
            title: '接待地点',
            dataIndex: 'receptionPlace',
            key: 'receptionPlace',
            width: 120,
        }];

        if (hasPendingPermission) {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                fixed: 'right',
                width: 140,
                render: (text, record) => (
                    <span>
                        <a onClick={() => this.pendingModalRef.show(record)}>修改</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.pendingDelete(record)}>删除</a>
                    </span>
                ),
            });
        }

        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = (data || []).map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    getPendingDataSource = () => {
        const { pendingData, pendingPagination } = this.state;
        const { current, pageSize } = pendingPagination;
        const dataSource = (pendingData || []).map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    handlePendingTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadPendingData();
        });
    }

    showUpdate = (updateVisible, record = {}) => {
        this.setState({
            record,
            updateVisible,
        });
    }

    showPreviewModal = record => {
        this.previewModalRef.show(record);
    }

    showTransferStationRecord = record => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryChangeDoctorPost,
            data: {
                userId: record.userId,
            },
            dataType: 'json',
            doneResult: res => {
               this.showTransferStationRecordRef.show(res.data);
            },
        };
        $.sendRequest(options);
    }

    showCooperation = (record) => {
        this.cooperationRef.show(record);
    }

    render() {
        const {
            isAdd, record, loading, pagination, searchParams, updateVisible, crcFlag,
            pendingSearchParams, pendingLoading, pendingPagination,
        } = this.state;
        const { hospitalName: pHospitalName, courtyardArea: pCourtyardArea, deptName: pDeptName, doctorName: pDoctorName } = pendingSearchParams;
        return (
            <div className="content">
                <SideNav selectKey='doctor' />
                <div className="main">
                    <Tabs defaultActiveKey="cooperating" type="card" style={{ padding: '0 10px' }}>
                        <TabPane tab="合作医生信息" key="cooperating">
                            <Filter
                                isAdd={isAdd}
                                crcFlag={crcFlag}
                                search={this.search}
                                export={this.export}
                                update={this.showUpdate}
                                searchParams={searchParams}
                                onChange={this.handleChange}
                            />
                            <TableC
                                columns={this.getColumns()}
                                data={this.getDataSource()}
                                loading={loading}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                            />
                        </TabPane>
                        <TabPane tab="待合作医生信息" key="pending">
                            <div className="filter-bar">
                                <div className="filter-bar-investigation">
                                    <div className="form-item">
                                        <label className="ui-label">医院官方名称</label>
                                        <Input
                                            placeholder="请输入"
                                            value={pHospitalName}
                                            onChange={e => this.handlePendingSearchChange(e.target.value, 'hospitalName')}
                                            onKeyPress={e => { if (e.charCode === 13) this.pendingSearch(); }}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label className="ui-label">院区</label>
                                        <Input
                                            placeholder="请输入"
                                            value={pCourtyardArea}
                                            onChange={e => this.handlePendingSearchChange(e.target.value, 'courtyardArea')}
                                            onKeyPress={e => { if (e.charCode === 13) this.pendingSearch(); }}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label className="ui-label">科室</label>
                                        <Input
                                            placeholder="请输入"
                                            value={pDeptName}
                                            onChange={e => this.handlePendingSearchChange(e.target.value, 'deptName')}
                                            onKeyPress={e => { if (e.charCode === 13) this.pendingSearch(); }}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label className="ui-label">医生</label>
                                        <Input
                                            placeholder="请输入"
                                            value={pDoctorName}
                                            onChange={e => this.handlePendingSearchChange(e.target.value, 'doctorName')}
                                            onKeyPress={e => { if (e.charCode === 13) this.pendingSearch(); }}
                                        />
                                    </div>
                                    <div className="form-item">
                                        {(sessionStorage.positionRole === 'CRCC' || sessionStorage.positionRole === 'CRCM' || !!this.props.menuAuth.areaChargeUser || sessionStorage.positionRole === 'PML' || sessionStorage.isClinicalBO === 'true') &&
                                            <Button type="primary" onClick={() => this.pendingModalRef.show()}>新增</Button>
                                        }
                                        <Button type="primary" onClick={this.pendingSearch}>搜索</Button>
                                    </div>
                                </div>
                            </div>
                            <TableC
                                columns={this.getPendingColumns()}
                                data={this.getPendingDataSource()}
                                loading={pendingLoading}
                                onChange={this.handlePendingTableChange}
                                pagination={pendingPagination}
                            />
                        </TabPane>
                    </Tabs>
                </div>
                <ExportModal ref={el => this.exportModal = el} />
                <UpdateDoctor visible={updateVisible} record={record} loadData={this.loadData} showUpdate={this.showUpdate} />
                <PreviewModal ref={el => this.previewModalRef = el} params={searchParams} />
                <TransferStationRecord ref={el => this.showTransferStationRecordRef = el} loadData={this.loadData} />
                <Cooperation ref={el => this.cooperationRef = el} type="DOCTOR" loadData={this.loadData} />
                <PendingDoctorModal ref={el => this.pendingModalRef = el} loadData={this.loadPendingData} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    searchParams: state.hospitalState.doctorInfoState.searchParams,
    menuAuth: state.menuState.menuAuth || {},
});

const mapDispatchToProps = (dispatch) => ({
    saveSearchParams: (params) => dispatch(actions.saveSearchParams(params)),
    saveParams: (params) => dispatch(saveParams(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DoctorList);



// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/index.js